import React, { useContext } from 'react'
import { ContentFooter } from '../../../../../layout/Content'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReportsController from '../../../../ReportsController'
import LogsFooterStyle from './css/LogsFooterStyle'
import { logsControllerContext } from './LogsController'

function LogsFooter(props) {
  const logsController = useContext(logsControllerContext)
  const { app } = logsController
  const setContent = app.content[1]

  return (
    <ContentFooter>
      <div className='content-footer-container'>
        <div className='action-btn-container'>
          <button
            onClick={() => { setContent(<ReportsController />) }}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='list-alt'/>&nbsp;Back to Reports
          </button>
        </div>
        <div className='action-btn-container'>
          <button
            onClick={ () => { window.print() } }
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='print'/>&nbsp;Print
          </button>
        </div>
      </div>
      <LogsFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(LogsFooter)